import { useEffect, useState, useCallback } from 'react'
import Certificates from "./components/Certificates.jsx";
import Experience from "./Sections/Experience.jsx";
import Navbar from "./components/Navbar.jsx";
import About from "./Sections/About.jsx";
import Hero from "./Sections/Hero.jsx";
import Projects from "./Sections/Projects.jsx";
import ConnectMe from "./Sections/ConnectMe.jsx";
import Loading from "./Sections/Loading.jsx";
import Desktop from "../macOS/components/Desktop/Desktop.jsx"
import { Link } from 'react-router-dom';


function V1Layout() {
    const [isLoading, setIsLoading] = useState(true);
    const [showMacOs, setShowMacOs] = useState(false);

    const handleFinish = useCallback(() => {
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 5000);

        return () => clearTimeout(timer);
    });
    return (
        <>
            {/* Loader stays on top */}
            {isLoading && <Loading onFinish={handleFinish} />}

            {/* App always rendered underneath */}
            {showMacOs ? (
                <Desktop closeMac={setShowMacOs} />
            ) : (
                <div className="snap-y snap-mandatory">
                    <Link to="/" className='fixed top-10 left-3 z-[999]'>
                    <h1 className='bg-black-main text-green-main px-4 py-1 rounded-full'> go back to v2 </h1>
                    </Link>
                    <Navbar />
                    <Hero mactoggle={setShowMacOs} startTyping={!isLoading} />
                    <About />
                    <Experience />
                    <Certificates />
                    <Projects />
                    <ConnectMe />
                </div>
            )}
        </>
    )
}

export default V1Layout